import { motion } from "framer-motion";
import { ShieldCheck, Zap, Sun } from "lucide-react";

export function HeroQuickQuote() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
      className="relative z-10 w-full lg:w-2/5 grid grid-cols-2 lg:flex lg:flex-col gap-3 lg:gap-4"
    >
      {/* SPEC 01 — Solvärme / kostnadsbesparing */}
      <div className="relative group overflow-hidden border border-cream/10 bg-cream/[0.04] backdrop-blur-md p-4 md:p-7 hover:border-gold/50 transition-all">
        <div className="hidden md:block absolute top-2 right-3 font-mono text-[10px] tracking-[0.2em] text-gold/40">
          SPEC_01
        </div>
        <div className="flex items-baseline gap-2 md:gap-3">
          <Sun size={18} className="text-gold-bright shrink-0 md:hidden" />
          <Sun size={20} className="text-gold-bright shrink-0 hidden md:block" />
          <div className="font-display text-3xl md:text-5xl lg:text-[3.25rem] text-gold-bright leading-none mb-1">
            −61 %
          </div>
        </div>
        <div className="mt-1 text-[10px] md:text-[11px] uppercase tracking-[0.18em] md:tracking-[0.22em] text-cream">
          Solvärme · 3M Prestige
        </div>
        <div className="mt-3 md:mt-5 h-[3px] w-full bg-cream/10 overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "61%" }}
            transition={{ duration: 1.2, delay: 0.8, ease: [0.4, 0, 0.2, 1] }}
            className="h-full bg-gradient-to-r from-gold to-gold-bright"
          />
        </div>
      </div>

      {/* SPEC 02 — UV-skydd */}
      <div className="relative group overflow-hidden border border-cream/10 bg-cream/[0.04] backdrop-blur-md p-4 md:p-7 hover:border-gold/50 transition-all">
        <div className="hidden md:block absolute top-2 right-3 font-mono text-[10px] tracking-[0.2em] text-gold/40">
          SPEC_02
        </div>
        <div className="flex items-baseline gap-2 md:gap-3">
          <ShieldCheck size={18} className="text-gold-bright shrink-0 md:hidden" />
          <ShieldCheck size={20} className="text-gold-bright shrink-0 hidden md:block" />
          <div className="font-display text-3xl md:text-5xl lg:text-[3.25rem] text-cream leading-none mb-1">
            &gt;99 %
          </div>
        </div>
        <div className="mt-1 text-[10px] md:text-[11px] uppercase tracking-[0.18em] md:tracking-[0.22em] text-cream/75">
          UV-skydd · blekning &amp; hud
        </div>
      </div>

      {/* SPEC 03 — ROI / kostnadsbesparing */}
      <div className="col-span-2 lg:col-span-1 relative group overflow-hidden border border-cream/10 bg-cream/[0.04] backdrop-blur-md p-4 md:p-7 hover:border-gold/50 transition-all">
        <div className="hidden md:block absolute top-2 right-3 font-mono text-[10px] tracking-[0.2em] text-gold/40">
          SPEC_03
        </div>
        <div className="flex items-baseline gap-2 md:gap-3">
          <Zap size={18} className="text-gold-bright shrink-0 md:hidden" />
          <Zap size={20} className="text-gold-bright shrink-0 hidden md:block" />
          <div className="font-display text-3xl md:text-5xl lg:text-[3.25rem] text-cream leading-none mb-1">
            3–5 år
          </div>
        </div>
        <div className="mt-1 text-[10px] md:text-[11px] uppercase tracking-[0.18em] md:tracking-[0.22em] text-cream/75">
          ROI · återbetalningstid
        </div>
      </div>

      {/* Floating 10 års badge */}
      <div className="absolute -top-4 -right-4 hidden xl:flex items-center justify-center w-24 h-24 rounded-full border-2 border-[#E6C870] bg-gradient-to-br from-[#F9E27A] via-[#D4AF37] to-[#AA7C18] shadow-[0_0_30px_rgba(212,175,55,0.55),inset_0_-2px_8px_rgba(0,0,0,0.15)] text-center rotate-[8deg]">
        <span className="text-[10px] font-bold text-navy leading-tight uppercase tracking-wider drop-shadow-[0_1px_0_rgba(255,255,255,0.4)]">
          10 års
          <br />
          garanti
        </span>
      </div>
    </motion.div>
  );
}
